// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price-filter {
  font-family: Arial, sans-serif;
  max-width: 300px;
  margin: auto;
}

.title {
  font-weight: bold;
  margin-bottom: 8px;
  display: block;
}

.fromTo {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.fromTo span {
  width: 45%;
  font-size: 14px;
  color: #333d47;
  line-height: 16px;
}

.inputs {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-bottom: 16px;
}

.inputs input {
  width: 100%;
  padding: 8px 12px;
  padding-left: 20px;
  border: 1px solid #eef0f2;
  border-radius: 8px;
  font-size: 14px;
}

.inputs span {
  position: relative;
  width: 45%;
  display: flex;
  align-items: center;
  color: #5d7083;
  font-weight: 600;
}
.inputs span span {
  position: absolute;
  width: fit-content;
  top: 50%;
  transform: translateY(-50%);
  left: 13px;
}

.slider-container {
  position: relative;
  width: 100%;
  height: 20px;
}

.slider {
  position: absolute;
  width: 100%;
  top: 7px;
  -webkit-appearance: none;
  appearance: none;
  pointer-events: none;
  background: transparent;
}

/* Slider Track */
.slider::-webkit-slider-runnable-track {
  height: 4px;
  background: #eef0f2;
  border-radius: 3px;
}

/* Active Track (Between Thumbs) */
.active-track {
  position: absolute;
  height: 4px;
  z-index: 1;
  top: 7px;
  background: #1e96fc;
  border-radius: 3px;
}

/* Slider Thumbs */
.slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: #1e96fc;
  z-index: 1;
  border-radius: 50%;
  filter: drop-shadow(0px 2px 2px rgba(48, 54, 60, 0.3));
  cursor: pointer;
  pointer-events: auto;
  border: 1px solid white;
  position: relative;
  z-index: 1;
  top: -8px; /* Moves thumb up */
}

/* Labels under slider */
.slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #333d47;
}
`, "",{"version":3,"sources":["webpack://./../../shared/components/ai/range-slider/range-slider.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,sDAAsD;EACtD,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,SAAS,EAAE,mBAAmB;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB","sourcesContent":[".price-filter {\n  font-family: Arial, sans-serif;\n  max-width: 300px;\n  margin: auto;\n}\n\n.title {\n  font-weight: bold;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.fromTo {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.fromTo span {\n  width: 45%;\n  font-size: 14px;\n  color: #333d47;\n  line-height: 16px;\n}\n\n.inputs {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.inputs input {\n  width: 100%;\n  padding: 8px 12px;\n  padding-left: 20px;\n  border: 1px solid #eef0f2;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.inputs span {\n  position: relative;\n  width: 45%;\n  display: flex;\n  align-items: center;\n  color: #5d7083;\n  font-weight: 600;\n}\n.inputs span span {\n  position: absolute;\n  width: fit-content;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 13px;\n}\n\n.slider-container {\n  position: relative;\n  width: 100%;\n  height: 20px;\n}\n\n.slider {\n  position: absolute;\n  width: 100%;\n  top: 7px;\n  -webkit-appearance: none;\n  appearance: none;\n  pointer-events: none;\n  background: transparent;\n}\n\n/* Slider Track */\n.slider::-webkit-slider-runnable-track {\n  height: 4px;\n  background: #eef0f2;\n  border-radius: 3px;\n}\n\n/* Active Track (Between Thumbs) */\n.active-track {\n  position: absolute;\n  height: 4px;\n  z-index: 1;\n  top: 7px;\n  background: #1e96fc;\n  border-radius: 3px;\n}\n\n/* Slider Thumbs */\n.slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #1e96fc;\n  z-index: 1;\n  border-radius: 50%;\n  filter: drop-shadow(0px 2px 2px rgba(48, 54, 60, 0.3));\n  cursor: pointer;\n  pointer-events: auto;\n  border: 1px solid white;\n  position: relative;\n  z-index: 1;\n  top: -8px; /* Moves thumb up */\n}\n\n/* Labels under slider */\n.slider-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #333d47;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
